import closeIcon from 'assets/icon--close-grey.svg';
import crossIcon from 'assets/icons/red_cross.png';
import { SecondaryButton } from 'components/ui/Button';
import { Input } from 'components/ui/Form/Input';
import { Table } from 'components/ui/Table';
import React from 'react';
import { getStaticMediaUrl } from 'utils/Urls';
import { toIndianCurrencyString } from 'utils/Numbers';
import styles from '../../index.module.scss';
import { EditPayrollProps, PayrollAllowance } from '../types';
import { ALLOWANCES_LIMIT } from 'components/RunPayroll/constants';

type AdditionsProps = EditPayrollProps & {
  allowances: PayrollAllowance[];
  onAllowanceChange: (updateIndex: number, propToUpdate: string, value: string | number) => void;
  onAddAllowance: () => void;
  onDeleteAllowance: (index: number) => void;
};

const Additions = ({
  payrollEntry,
  allowances,
  onAllowanceChange,
  onAddAllowance,
  onDeleteAllowance,
}: AdditionsProps) => {
  const onHoverDeleteButton = (idx: number) => {
    if (idx >= 2) {
      const row = document.getElementById(`addition-row-${idx}`);
      row?.classList.add(styles['run-payroll-deduction-row-hover']);
    }
  };

  const onMouseoutOfDeleteButton = (idx: number) => {
    if (idx >= 2) {
      const row = document.getElementById(`addition-row-${idx}`);
      row?.classList.remove(styles['run-payroll-deduction-row-hover']);
    }
  };

  return (
    <div>
      <Table
        className="w-full  border border-solid border-surfaceBorderGraySubtle"
        showAlternateColors={false}>
        <thead>
          <tr>
            <th>Label</th>
            <th>Amount</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {payrollEntry.adhocAllowances?.map((otp) => {
            return (
              <tr key={otp.name}>
                <td>{otp.name}*</td>
                <td>{toIndianCurrencyString(otp.amount, true)}</td>
                <td></td>
              </tr>
            );
          })}
          {allowances.map((allowance, idx) => {
            return (
              <tr key={idx} id={`addition-row-${idx}`}>
                <td>
                  <Input
                    type="text"
                    data-testid={`allowance-${allowance.name}-name`}
                    name={`name-${idx}`}
                    value={allowance.name ?? ''}
                    placeholder="Eg. Bonus, Travel Allowance etc."
                    onChange={(event) => {
                      onAllowanceChange(idx, 'name', event.target.value);
                    }}
                  />
                </td>
                <td>
                  <Input
                    type="number"
                    data-testid={`allowance-${allowance.name}-value`}
                    className={styles['run-payroll-edit-number']}
                    name={`amount-${idx}`}
                    value={allowance.amount ? allowance.amount : ''}
                    onChange={(event) => {
                      onAllowanceChange(idx, 'amount', event.target.value);
                    }}
                  />
                </td>
                {idx >= 2 ? (
                  <td
                    onMouseOver={() => onHoverDeleteButton(idx)}
                    onMouseOut={() => onMouseoutOfDeleteButton(idx)}>
                    {
                      <>
                        <img
                          className={styles['run-payroll-deduction-red-cross']}
                          src={getStaticMediaUrl(crossIcon)}
                          alt=""
                          onClick={() => onDeleteAllowance(idx)}
                        />
                        <img
                          className={styles['run-payroll-deduction-grey-close']}
                          src={getStaticMediaUrl(closeIcon)}
                          alt=""
                          onClick={() => onDeleteAllowance(idx)}
                        />
                      </>
                    }
                  </td>
                ) : (
                  <td />
                )}
              </tr>
            );
          })}
        </tbody>
      </Table>
      {payrollEntry.adhocAllowances && payrollEntry.adhocAllowances.length > 0 && (
        <div className="mt-5">* indicates one-time payment paid to employee.</div>
      )}
      {allowances.length < ALLOWANCES_LIMIT && (
        <SecondaryButton
          onClick={onAddAllowance}
          disabled={false}
          className={styles['run-payroll-new-deduction-button']}
          type="button">
          + New addition
        </SecondaryButton>
      )}
    </div>
  );
};

export default Additions;
